import { makeStyles } from "tss-react/mui";

const useItemFieldStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "5px 0",
    lineHeight: "23px",
    alignItems: "center",
    paddingLeft: "15px",
    paddingRight: "15px",
    backgroundColor: theme.palette.surface.light,
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.strokes.defaultGrey}`,
  },
  borders: {
    border: `1px solid ${theme.palette.strokes.defaultGrey}`,
    borderRadius: "4px",
  },
  left: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    overflow: "hidden",
    fontWeight: "500",
  },
  right: {
    display: "flex",
    flexDirection: "row",
    textAlign: "right",
    justifyContent: "flex-end",
    flexWrap: "nowrap",
  },
  bottomLeft: {
    fontSize: "14px",
    fontWeight: "400",
  },
  columnsRight: {
    display: "flex",
    flexDirection: "column",
    paddingRight: "2px",
    gap: "1px",
    minHeight: "20px",           
    width: "100%",              
    minWidth: "10px",            
    flexGrow: 1,    

    "& div:first-of-type": {
      borderRadius: "4px 4px 0 0",
    },

    "& div:first-of-type.roundedCorners": {
      borderRadius: "4px",
    },

    "& div:nth-of-type(2)": {
      borderRadius: "0 0 4px 4px",
    },
  },
  lines: {
    lineHeight: "21px",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  qtyDiv: {
    backgroundColor: theme.palette.surface.darker,
    display: "flex",
    padding: "0 6px",
    color: theme.palette.text.primary,
    justifyContent: "center",    
    alignItems: "center",        
    width: "100%",               
    minHeight: "10px",           
    minWidth: "25px",          
    textAlign: "center", 
  },
  limitedHeight: {
    height: "58.8px",
  },
  noWrap: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  collectedItem: {
    color: theme.palette.primary.main,
  },
  selectedRow: {
    animation: "$target-fade 3s 1",
    WebkitAnimation: "$target-fade 3s 1",
    MozAnimation: "$target-fade 3s 1",
  },
  element1: {
    display: "flex",
  },
  "@keyframes target-fade": {
    "0%": {
      backgroundColor: "rgba(0, 179, 115,0.8)",
    },
    "100%": {
      backgroundcolor: "rgba(0, 179, 115,0)",
    },
  },
  collectedRow: {
    backgroundColor: theme.palette.surface.selected,
  },
  collectedRowsQty: {
    backgroundColor: theme.palette.surface.highlightedLighter,
  },
}));

export default useItemFieldStyles;
